import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.showModal();
    $(this.element).on('hidden.bs.modal', this.handleModalHidden.bind(this));
  }

  showModal() {
    const modal = new bootstrap.Modal(this.element);
    modal.show();
  }

  handleModalHidden() {
    fetch('/migration_notice/dismiss', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken()
      }
    }).then(() => {
      this.element.innerHTML = '';
    });
  }
}
